import { createSlice } from '@reduxjs/toolkit';

const initialFormData = {
  id: '',
  employee_nik: '',
  employee_name: '',
  employee_foto: '',
  employee_foto_url: '',
  foto_km: '',
  employee_date: '',
  employee_waktu: '',
  employee_address: '',
  employee_longlat: '',
  employee_role: '',
  employee_date_end: '',
  employee_waktu_end: '',
  employee_foto_end: '',
  employee_foto_end_url: '',
  employee_address_end: '',
  employee_longlat_end: '',
  employee_divisi: '',
  employee_jabatan: '',
  employee_worklocation: '',
  reference_id: '',
  prop: [],
  log: [],
  tabs: {
    log: 'Log',
    record: 'Record',
  },
};

const normalizePayload = (payload) => {
  const header = payload?.Header || payload?.header || payload || {};
  const detail = payload?.D || payload?.Detail || payload?.detail || {};

  return {
    ...header,
    prop: Array.isArray(detail.Prop) ? detail.Prop : Array.isArray(detail.prop) ? detail.prop : [],
    log: Array.isArray(detail.Log) ? detail.Log : Array.isArray(detail.log) ? detail.log : [],
  };
};

const initialState = {
  selectedRow: null,
  formData: initialFormData,
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const ops07dailyabsenSlice = createSlice({
  name: 'ops07dailyabsen',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialFormData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      const payload = normalizePayload(action.payload || {});
      state.formData = {
        ...initialFormData,
        ...payload,
        tabs: payload?.tabs || initialFormData.tabs,
      };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialFormData;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  resetState,
  setActiveTab,
  clearModuleState,
} = ops07dailyabsenSlice.actions;

export default ops07dailyabsenSlice.reducer;
